import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalWrapper from "../modals/ModalWrapper";
import { useCookies } from "react-cookie";
import { HELLO_RADIUS_COOKIE } from "../../layout/CookieWrapper";
import { Accordion, Button, Icon, Segment } from "semantic-ui-react";
import { SEMANTIC_DIV } from "../../../css/styles";
import { closeModal } from "../modals/modalReducer";
import { COOKIES_ROUTE } from "../../api/routeConstants";
import UxToggle from "./UxToggle";
import TextLink from "./TextLink";
// import { logCookieConsent } from "../../firestore/firestoreService";
// import cuid from "cuid";

const ELEVEN_MONTHS_FIFTEEN_DAYS = 29808000;
const ONE_DAY = 86400;

// const COOKIE_CONSENT_USER_ID = "_hr_ccid";
const COOKIE_CONSENT_DATE_TIMESTAMP = "_hr_ccd";

export default function CookieConsentModal({ openSettings = false }) {
  const dispatch = useDispatch();

  const { responsive } = useSelector((state) => state.app);

  // do not remove unused cookies
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies();
  const [isCookieSettingsOpen, setIsCookieSettingsOpen] =
    useState(openSettings);
  const [isEssentialAccordionOpen, setIsEssentialAccordionOpen] =
    useState(false);
  const [isNonEssentialAccordionOpen, setIsNonEssentialAccordionOpen] =
    useState(false);
  const [acceptNonEssential, setAcceptNonEssential] = useState(true);

  // async function logCookieUserId({ cookieConsent, cookieExpiryDate }) {
  //   const userId = cuid();
  //   setCookie(COOKIE_CONSENT_USER_ID, cookieConsent + "-" + userId, {
  //     path: "/",
  //     maxAge: cookieExpiryDate,
  //   });
  //   await logCookieConsent({ userId, cookieConsent });
  // }

  function handleSave(isAcceptAll) {
    const cookieConsent = isAcceptAll || acceptNonEssential ? "1" : "0";
    const cookieExpiryDate =
      isAcceptAll || acceptNonEssential ? ELEVEN_MONTHS_FIFTEEN_DAYS : ONE_DAY;
    setCookie(HELLO_RADIUS_COOKIE, cookieConsent, {
      path: "/",
      maxAge: cookieExpiryDate,
    });
    setCookie(COOKIE_CONSENT_DATE_TIMESTAMP, Date.now().toString(), {
      path: "/",
      maxAge: cookieExpiryDate,
    });
    // logCookieUserId({
    //   cookieConsent,
    //   cookieExpiryDate,
    // }).then(() => console.log("cookie consent logged"));
    dispatch(closeModal());
  }

  return (
    <ModalWrapper
      size="tiny"
      modalClassName="modal-ux-wrapper"
      closeOnEscape={false}
      closeOnDimmerClick={false}
      isClose={false}
      showAnimation={"fade"}
      hideAnimation={"fade"}
      showDuration={200}
      hideDuration={200}
      padding={!responsive.isMobile ? 26 : 8}
    >
      {!isCookieSettingsOpen && (
        <div>
          <div className="body-bold-text" style={{ marginBottom: 12 }}>
            Your Cookie Preferences
          </div>
          <div>
            Hello Radius uses cookies to provide you with a better experience,
            such as enabling basic site functions and remembering your privacy
            settings, as well as analysing site traffic and usage. You can
            manage your cookie preferences by clicking on "Cookie settings". By
            clicking "Accept all" you agree to our use of cookies detailed in
            our <br />
            <TextLink
              text={"Cookie Policy"}
              to={COOKIES_ROUTE}
              fontSize={16}
              rel="noopener noreferrer"
              target="_blank"
            />
            .
          </div>
          <div className="center-flex" style={{ marginTop: 35 }}>
            <Button
              className={"text-button"}
              content={"Cookie settings"}
              onClick={() => {
                setAcceptNonEssential(false);
                setIsCookieSettingsOpen(true);
              }}
              style={{ margin: "0 8px" }}
            />
            <Button
              className="overwrite-button cta-blue"
              content="Accept all"
              onClick={() => handleSave(true)}
              style={{ margin: "0 8px" }}
            />
          </div>
        </div>
      )}
      {isCookieSettingsOpen && (
        <div>
          <div className="body-bold-text" style={{ marginBottom: 12 }}>
            Cookie Settings
          </div>
          <div>
            Our platform uses first-party and third-party cookies. Some of the
            cookies we use are essential for critical functions and are always
            enabled. We also use non-essential cookies to understand how you use
            our platform. For further details about the specific cookies we use,
            see our{" "}
            <TextLink
              text={"Cookie Policy"}
              to={COOKIES_ROUTE}
              fontSize={16}
              rel="noopener noreferrer"
              target="_blank"
            />
            .
          </div>
          <div style={{ marginTop: 22 }}>
            <Accordion>
              <div
                style={{
                  borderRadius: 11,
                  border: "1px solid #55A6CA",
                  padding: "0 15px",
                }}
              >
                <Accordion.Title
                  active={isEssentialAccordionOpen}
                  index={0}
                  style={{ cursor: "default" }}
                >
                  <div className="display-flex" style={{ width: "100%" }}>
                    <div
                      style={{ width: "60%" }}
                      onClick={() => {
                        setIsNonEssentialAccordionOpen(false);
                        setIsEssentialAccordionOpen(!isEssentialAccordionOpen);
                      }}
                    >
                      <div
                        className="body-blue-text clickable"
                        style={{ width: "fit-content" }}
                      >
                        <Icon name="dropdown" />
                        <span>Functional cookies</span>
                      </div>
                    </div>
                    <div
                      className="body-blue-text medium-text"
                      style={{ width: "40%", textAlign: "right" }}
                    >
                      <span>Always Enabled</span>
                    </div>
                  </div>
                </Accordion.Title>
                <Accordion.Content
                  active={isEssentialAccordionOpen}
                  style={{ padding: 7 }}
                >
                  <div>
                    Functional cookies are strictly necessary for our platform
                    and services to operate, to make it usable and secure. We
                    use the following functional cookies:
                  </div>
                  <div>
                    <ul>
                      <li key={1}>Store privacy preferences (first-party)</li>
                      <li key={2}>
                        Remember site maintenance notification preferences
                        (first-party)
                      </li>
                      <li key={3}>
                        Detect and prevent fraudulent activity (third-party)
                      </li>
                    </ul>
                  </div>
                </Accordion.Content>
              </div>
              <div
                style={{
                  borderRadius: 11,
                  border: "1px solid #55A6CA",
                  padding: "0 15px",
                  marginTop: 11,
                }}
              >
                <Accordion.Title
                  active={isNonEssentialAccordionOpen}
                  index={0}
                  style={{ cursor: "default" }}
                >
                  <div className="display-flex" style={{ width: "100%" }}>
                    <div
                      style={{ width: "50%" }}
                      onClick={() => {
                        setIsEssentialAccordionOpen(false);
                        setIsNonEssentialAccordionOpen(
                          !isNonEssentialAccordionOpen
                        );
                      }}
                    >
                      <div
                        className="body-blue-text clickable"
                        style={{ width: "fit-content" }}
                      >
                        <Icon name="dropdown" />
                        <span>Analytical cookies</span>
                      </div>
                    </div>
                    <div
                      className="body-blue-text medium-text"
                      style={{ width: "50%", textAlign: "right" }}
                    >
                      <span>
                        <Segment
                          basic
                          style={{ ...SEMANTIC_DIV }}
                          floated={"right"}
                        >
                          <UxToggle
                            labelText={
                              acceptNonEssential ? "Enabled" : "Disabled"
                            }
                            inverse={true}
                            checked={acceptNonEssential}
                            handleClick={() =>
                              setAcceptNonEssential(!acceptNonEssential)
                            }
                          />
                        </Segment>
                      </span>
                    </div>
                  </div>
                </Accordion.Title>
                <Accordion.Content
                  active={isNonEssentialAccordionOpen}
                  style={{ padding: 7 }}
                >
                  <div>
                    We use first-party analytical cookies to collect information
                    about how you use our platform and report platform usage
                    statistics. These statistics help us to improve our services
                    and your experience.
                  </div>
                  <div style={{ marginTop: 8 }}>
                    These cookies are not essential for our platform to operate
                    and do not collect data that can personally identify anyone.
                  </div>
                </Accordion.Content>
              </div>
            </Accordion>
            <Button
              className="overwrite-button cta-blue"
              content="Confirm my choices"
              onClick={() => handleSave(false)}
              style={{ margin: "14px 0 17px" }}
              floated={"right"}
            />
          </div>
        </div>
      )}
    </ModalWrapper>
  );
}
